/**
 * Org vs project screener navigation helpers.
 */

import store from '@/store';

export function getScreenerContext(route) {
  const projectId = route?.params?.projectId || null;
  return {
    projectId,
    isProject: Boolean(projectId),
  };
}

export function screenerRouteNames(isProject) {
  if (isProject) {
    return {
      list: 'Project Screener',
      create: 'Project Screener Create',
      edit: 'Project Screener Edit',
      preview: 'Project Screener Preview',
      take: 'Project Screener Take',
      questions: 'Project Screener Questions',
      responses: 'Project Screener Responses',
    };
  }

  return {
    list: 'OptInForm',
    create: 'ScreenerCreate',
    edit: 'ScreenerEdit',
    preview: 'ScreenerPreview',
    take: 'WorkspaceOptInForm',
    questions: 'ScreenerQuestions',
    responses: 'ScreenerResponses',
  };
}

export function screenerLocation(route, type, { screenerId, query = {} } = {}) {
  const { projectId, isProject } = getScreenerContext(route);
  const names = screenerRouteNames(isProject);
  const params = {};

  if (isProject) params.projectId = projectId;
  if (names[type] === 'WorkspaceOptInForm') {
    params.workspaceId = store.state.userWorkspace?.id || screenerId;
  } else if (screenerId) {
    params.screenerId = screenerId;
  }

  return {
    name: names[type],
    params,
    query,
  };
}

export function screenerListPath(route) {
  const { projectId, isProject } = getScreenerContext(route);
  return isProject
    ? `/project/${projectId}/screener`
    : '/settings?tab=opt-in-form';
}

export function screenerTakeUrl(origin, route, screenerId, token = '') {
  const { projectId, isProject } = getScreenerContext(route);
  if (isProject) {
    // Email invite links: domain/project/screener/{token}
    if (token) {
      return `${origin}/project/screener/${token}`;
    }
    return `${origin}/project/${projectId}/screener/${screenerId}`;
  }
  const workspaceId = store.state.userWorkspace?.id;
  return `${origin}/opt-in-form/${workspaceId || screenerId}`;
}
